import { STALE_CREDENTIAL_MILLIS } from "@p0security/shared/assessment/dsl";
import { IdentityCredentials } from "@p0security/shared/types/assessment/data/identity";
import { DAYS } from "@p0security/util/time";
import { groupBy } from "lodash";

export const credentialsByUsage = (credentials: IdentityCredentials) => {
  const threshold = Date.now() - 90 * DAYS;
  // Only use credentials for which staleness is known
  const filteredCredentials = credentials.filter((c) => c.lastAuthnTime);
  return groupBy(filteredCredentials, (c) =>
    (c.lastAuthnTime ?? 0) >= threshold
      ? ("used" as const)
      : ("unused" as const)
  );
};

export const credentialsByStaleness = (credentials: IdentityCredentials) => {
  const threshold = Date.now() - STALE_CREDENTIAL_MILLIS;
  // Only use credentials for which staleness is known
  const filteredCredentials = credentials.filter(
    (c) => c.type === "short-lived" || c.createdTime
  );
  return groupBy(filteredCredentials, (c) =>
    c.type === "short-lived" || (c.createdTime && c.createdTime >= threshold)
      ? ("fresh" as const)
      : ("stale" as const)
  );
};
